export const DOCUMENT_MASK = {
  ANG: {
    label: 'NIF'
  },
  ARG: {
    label: 'CUIT/CUIL',
    mask: '99-99999999-9',
    placeholder: '00-00000000-0'
  },
  AUS: {
    label: 'ABN',
    mask: '99 999 999 999',
    placeholder: '00 000 000 000'
  },
  BOL: {
    label: 'NIT'
  },
  CHI: {
    label: 'RUT',
    mask: 'xx.999.999-x',
    placeholder: 'XX.000.000-X'
  },
  COL: {
    label: 'NIT',
    mask: '999.999.999-9',
    placeholder: '000.000.000-0'
  },
  COS: {
    label: 'Ced. Fis/Jur'
  },
  DOM: {
    label: 'RNC/CIE',
    mask: '9-99-99999-9',
    placeholder: '0-00-00000-0'
  },
  EQU: {
    label: 'RUC'
  },
  EUA: {
    label: 'FED.ID/SS',
    mask: 'xxx-xx-xxxx',
    placeholder: 'xxx-xx-xxxx'
  },
  HAI: {
    label: 'NIF'
  },
  MEX: {
    label: 'RFC'
  },
  PAD: {
    label: 'RNC/CIE',
    mask: '9-99-99999-9',
    placeholder: '0-00-00000-0'
  },
  PAN: {
    label: 'CUIT/CUIL',
    mask: '99-99999999-9',
    placeholder: '00-00000000-0'
  },
  PAR: {
    label: 'RUC',
    mask: '9999999999',
    placeholder: '0000000000'
  },
  PER: {
    label: 'RUC',
    mask: '99999999999',
    placeholder: '00000000000'
  },
  POR: {
    label: 'NP/SS',
    mask: 'XXX-XX-XXXX',
    placeholder: 'XXX-XX-XXXX'
  },
  PTG: {
    label: 'NIF'
  },
  RUS: {
    label: 'RNC/CIE',
    mask: '9-99-99999-9',
    placeholder: '0-00-00000-0'
  },
  SAL: {
    label: 'Reg. Fiscal',
    mask: '999999999-9',
    placeholder: '000000000-0'
  },
  URU: {
    label: 'RUC',
    mask: '99-999999-9999',
    placeholder: '00-000000-0000'
  },
  VEN: {
    label: 'RIF',
    mask: 'X-99999999-9',
    placeholder: 'X-00000000-0'
  }
};
export const DOCUMENT_MASK_OF_BRA = {
  F: {
    label: 'CPF',
    mask: '999.999.999-99',
    placeholder: '000.000.000-00'
  },
  J: {
    label: 'CNPJ',
    mask: '99.999.999/9999-99',
    placeholder: '00.000.000/0000-00'
  }
};
